<!--
우편번호 검색 컴포넌트 (카카오 주소검색 API)
https://postcode.map.daum.net/guide

2026-04-23 TASK-003
- CDN 도메인을 레거시 daumcdn.net → kakaocdn.net 으로 교체 (2026-05-12 레거시 도메인 물리 삭제 예정)
- API / 전역 `daum.Postcode` 네임스페이스 / 콜백 스키마는 모두 불변

과거 참고:
https://github.com/daumPostcode/QnA/issues/732  (GitHub 조직명은 그대로 `daumPostcode`)
-->

<script>
    export default {
        props: {

        },
        data: function () {
            return {
                /**
                 * 모듈로드 상태
                 *  - unload
                 *  - laoding
                 *  - laoded
                 */
                loadState: 'unload',
            };
        },
        computed: {
        },
        methods: {

            /**
             * 모듈로드
             * @return Promise
             */
            load() {
                if (window.daum || this.loadState !== 'unload') {
                    return new Promise((resolve) => {
                        resolve();
                    });
                }

                // 모듈 한번도 로드된적 없음
                return new Promise((resolve, reject) => {
                    this.loadState = 'loading';

                    // TASK-003 (2026-04-23): t1.daumcdn.net → t1.kakaocdn.net 로 CDN 도메인 교체
                    $.ajax({
                        url: 'https://t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js',
                        dataType: "script",
                        cache: true
                    }).done(() => {
                        // 스크립트 로드 성공
                        this.loadState = 'loaded';
                        //console.log('done ! ');
                        resolve();

                    }).fail(() => {
                        // 스크립트 로드 실패
                        this.loadState = 'unload';
                        alert('우편번호 검색모듈 조회에 실패했습니다. 다시 시도하세요');
                        //console.log('fail ! ');
                        reject();

                    });
                });

            },

            /**
             * 검색 팝업
             * @return void
             */
            search() {
                let promise = this.load();
                let cmp = this;

                // 팝업
                promise.then(() => {
                    new daum.Postcode({
                        oncomplete: function(data) {
                            // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

                            // 각 주소의 노출 규칙에 따라 주소를 조합한다.
                            // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
                            let addr = ''; // 주소 변수
                            let extraAddr = ''; // 참고항목 변수

                            //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
                            if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
                                addr = data.roadAddress;
                            } else { // 사용자가 지번 주소를 선택했을 경우(J)
                                addr = data.jibunAddress;
                            }

                            /**
                             * 20190530
                             * 아래는 참고항목 가져오는건데, 주소에 참고항목안써도 괜찮다고 함. 사용안하기로 함.
                             */

                            /*
                            // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
                            if(data.userSelectedType === 'R'){
                                // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                                // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                                if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){
                                    extraAddr += data.bname;
                                }
                                // 건물명이 있고, 공동주택일 경우 추가한다.
                                if(data.buildingName !== '' && data.apartment === 'Y'){
                                    extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
                                }
                                // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                                if(extraAddr !== ''){
                                    extraAddr = ' (' + extraAddr + ')';
                                }
                                // 조합된 참고항목을 해당 필드에 넣는다.
                                document.getElementById("sample6_extraAddress").value = extraAddr;

                            } else {
                                document.getElementById("sample6_extraAddress").value = '';
                            }
                            */

                            // 이벤트 발생
                            let value = {
                                zipcode: data.zonecode,
                                addr: addr,
                            };
                            cmp.$emit('found', value);
                        }
                    }).open();
                });


            },
        },
    }
</script>